import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section5: FC = () => {
  return (
    <section>
      <L_Section5>
        <L_Section5_T>클래스유는 다릅니다.</L_Section5_T>
        <L_Section5_B>
          <L_Section5_B_Contents>
            170만의 회원에게 직접 검증받은 데이터를 토대로
            <br />
            기업에 도움이 되는 콘텐츠를 제공합니다.
            {/* <br />
            <br /> */}
          </L_Section5_B_Contents>
        </L_Section5_B>
        <L_DiffIcons>
          <img
            src="https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A25%3A38/image-removebg-preview_(1).png"
            alt="clu_system"
          />
          <img
            src="https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A25%3A48/image-removebg-preview.png"
            alt="clu_system"
          />
        </L_DiffIcons>
      </L_Section5>
    </section>
  );
};
export default Section5;

const L_Section5_B = styled.div`
  margin-bottom: 4rem;
`;
const L_Section5_B_Contents = styled.p`
  color: ${palette.grey50};
  font-size: 1.6rem;
`;
const L_Section5_T = styled.p`
  font-weight: 700;
  color: inherit;
  font-size: 2.4rem;
  color: ${palette.grey75};
  margin-bottom: 4rem;
`;
const L_Section5 = styled.div`
  background: ${palette.system.BLACK};
  padding-top: 8rem;
  padding-bottom: 8rem;
  text-align: center;
`;

const L_DiffIcons = styled.div`
  max-width: calc(2 * 30rem);
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 0 3rem;
    row-gap: 3rem;
    grid-template-columns: 1fr;
  }
`;
